import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IWidget, ClockWidget } from "src/app/models/dashboard";
import { WidgetComponent } from 'src/app/views/dashboard/widgets/widget/widget.component';
import { Dashboard } from 'src/api/models';

@Component({
  selector: 'app-clock-widget',
  templateUrl: './clock-widget.component.html',
  styleUrls: ['./clock-widget.component.css']
})
export class ClockWidgetComponent implements OnInit, IWidget {
  @Output() dashboardSelected = new EventEmitter<any>();
  @Output() widgetSelected = new EventEmitter<any>();
  
  state:any;
  widgetComponent: WidgetComponent;
  widget: ClockWidget;
  dashboard: Dashboard;
  uri: string;
  currentTime: Date = new Date();

  loadComplete(){
    
  }
  
  constructor() {
  }

  ngOnInit() {
    setInterval(()=>{
        this.currentTime = new Date();
    }, 1000);
    console.log(this.widget);
  }

}
